import { Link } from "react-router-dom";

// public pages, so they work before signing in
export const TermsLink = ({ children = "Términos y condiciones", testId, newTab }) => (
  <Link to="/legal/terminos" className="text-acento-texto underline underline-offset-2" data-testid={testId}
    {...(newTab ? { target: "_blank", rel: "noopener" } : {})}>{children}</Link>
);
export const PrivacyLink = ({ children = "Aviso de privacidad", testId, newTab }) => (
  <Link to="/legal/privacidad" className="text-acento-texto underline underline-offset-2" data-testid={testId}
    {...(newTab ? { target: "_blank", rel: "noopener" } : {})}>{children}</Link>
);

export const ConsentChecks = ({ value, onChange, prefix }) => (
  <div className="space-y-3" data-testid={`${prefix}-consent`}>
    <label className="flex items-start gap-3 text-[14px] text-tinta leading-snug">
      <input type="checkbox" required checked={value.terms} onChange={(e) => onChange({ ...value, terms: e.target.checked })}
        className="mt-0.5 h-5 w-5 shrink-0 accent-[var(--tinta)]" data-testid={`${prefix}-accept-terms`} />
      <span>Acepto los <TermsLink newTab testId={`${prefix}-terms-link`} /> y confirmo que tengo 18 años o más.</span>
    </label>
    <label className="flex items-start gap-3 text-[14px] text-tinta leading-snug">
      <input type="checkbox" required checked={value.privacy} onChange={(e) => onChange({ ...value, privacy: e.target.checked })}
        className="mt-0.5 h-5 w-5 shrink-0 accent-[var(--tinta)]" data-testid={`${prefix}-accept-privacy`} />
      <span>Doy mi consentimiento expreso para el tratamiento de mis datos sensibles conforme al <PrivacyLink newTab testId={`${prefix}-privacy-link`} />.</span>
    </label>
  </div>
);
